export default class Counter {
    constructor (string) {
        if(string !== 'This is the first load.') {
            this.string = string.trim();
            this.array = this.string.split(" ");
            this.size = this.array.length;
            (this.string.length === 0) ? this.error(1) : this.countIt(this.array);
        } else {
            this.talkShit('start');
        }
    }

    cleanUp() {
        let output = document.querySelector(".output");
        let error = document.querySelector(".output .error p");
        let count = document.querySelector(".output .count p");
        let specChar = document.querySelector(".output .spec-char p");
        output.style.opacity = 0; 
        error.innerHTML = "";
        count.innerHTML = "";
        specChar.innerHTML = "";
        clearInterval();
    }

    talkShit(cookie) {
        const output = document.querySelector('.high-score');

        function getCookie(cname) {
                var name = cname + "=";
                var ca = document.cookie.split(';');
                for(var i = 0; i < ca.length; i++) {
                    var c = ca[i];
                    while (c.charAt(0) == ' ') {
                    c = c.substring(1);
                    }
                    if (c.indexOf(name) == 0) {
                    return c.substring(name.length, c.length);
                    }
                }
                return "";
        }

        function reanimate() {
            output.classList.remove('new-update');
            setTimeout( () => {
                output.classList.add('new-update');
            }, 100)
        }
        
        function setCookie(cvalue) {
            document.cookie = "record=" + cvalue;
        }

        function newHigh(val) {
            output.innerHTML = "New High Score: " + val;
            reanimate();
        }

        function notQuite(val) {
            output.innerHTML = "Not quite...High Score still: " + val;
            reanimate();
        }
        
        function initialScore(val) {
            output.innerHTML = "High Score: " + val;
            reanimate();
        }
          
        function checkCookie(value) {
            let check = getCookie('record');
            if(value === 'start') {
                initialScore(check);
            } else if(value > check) {
                setCookie(value);
                newHigh(value);
            } else {
                notQuite(check);
            }
        }

        checkCookie(cookie);

    }

    error(num) {
        this.cleanUp();
        let output = document.querySelector(".output");
        let error = document.querySelector(".output .error p");
        switch (num) {
            case 1:
                output.style.opacity = 1;
                error.innerHTML = 'You must enter something below first <span>&#8595;</span>';
                break;
        }
    }

    countIt(array) {
        this.cleanUp();
        let output = document.querySelector(".output");
        let count = document.querySelector(".output .count p");
        let specChar = document.querySelector(".output .spec-char p");
        let charCount = array.join(" ");
        let charCountnw = array.join("");
        let counter = 0;
        let speed;
        if(array.length <= 100) {
            speed = 100;
        } else if (array.length <=500){
            speed = 50;
        } else {
            speed = 10;
        }

        let int4 = setInterval( () => {
                if (counter < array.length && counter <= 100) {
                    count.innerHTML = "Words<br>" + counter++ + "<br><br><br><br><br>";
                    specChar.innerHTML = "You should have just counted on your hands";
                } else if (counter < array.length && counter <= 200) {
                    count.innerHTML = "Words<br>" + counter++ + "<br><br><br><br><br>";
                    specChar.innerHTML = "Or maybe used your feet as well";
                } else if (counter < array.length && counter <= 300) {
                    count.innerHTML = "Words<br>" + counter++ + "<br><br><br><br><br>";
                    if (!specChar.classList.contains('low')){
                        specChar.classList.add('low');
                    }
                    specChar.innerHTML = "Ok that's getting up there";
                } else if (counter < array.length && counter <= 500) {
                    count.innerHTML = "Words<br>" + counter++ + "<br><br><br><br><br>";
                    specChar.innerHTML = "Amazing!";
                } else if (counter < array.length && counter <= 700) {
                    count.innerHTML = "Words<br>" + counter++ + "<br><br><br><br><br>";
                    specChar.innerHTML = "Incredible!";
                } else if (counter < array.length && counter <= 1000) {
                    count.innerHTML = "Words<br>" + counter++ + "<br><br><br><br><br>";
                    specChar.innerHTML = "Huge!";
                } else if (counter < array.length && counter <= 1500) {
                    count.innerHTML = "Words<br>" + counter++ + "<br><br><br><br><br>";
                    specChar.innerHTML = "BONUS POINTS!!!!";
                } else if (counter < array.length && counter <= 3000) {
                    count.innerHTML = "Words<br>" + counter++ + "<br><br><br><br><br>";
                    specChar.innerHTML = "I'm having trouble counting that high.";
                } else if (counter < array.length && counter <= 3500) {
                    count.innerHTML = "Words<br>" + counter++ + "<br><br><br><br><br>";
                    specChar.innerHTML = "We're just going to let this finish...";
                } else {
                    count.innerHTML = "Words<br>" + counter++ + "<br>Characters with white space<br>" + charCount.length + "<br>Characters without white space<br>" + charCountnw.length;
                    counter--;
                    this.talkShit(counter);
                    clearInterval(int4);
                }
        }, speed)

        output.style.opacity = 1;
    }
}